export const zIndex = {
  base: 0,
  sticky: 10,
  dropdown: 200,
  overlay: 300,
  modal: 400,
  toast: 500,
} as const;
